import React, { FunctionComponent, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { CurrentUserType } from 'src/ducks/auth'
import LoadIcon from '../../components/LoadIcon'
import PageWithBg from '../../components/PageWithBg'
import config from '../../config'
import MalexLogo from '../../images/backdrops/malex-logo.png'
import SmithNephew from '../../images/backdrops/smithNephew-logo.png'
import routes from '../../routes'
import Amplitude from '../../utils/amplitudeHelper'
import { useAutoMute } from '../../utils/useAutoMute'
import { StyledTheatre } from './styled'

interface TheatreTypes {
  currentUser: CurrentUserType
  hallNumber: number
  liveUrl?: string
}
const TheatrePage: FunctionComponent<TheatreTypes> = ({ currentUser, hallNumber, liveUrl }) => {
  useAutoMute()
  const history = useHistory()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    document.title = hallNumber === 1 ? `${config.eventName} | Smith Nephew` : `${config.eventName} | Malex`
  }, [hallNumber])

  useEffect(() => {
    Amplitude.visit(hallNumber === 1 ? 'Theatre - Smith Nephew' : 'Theatre - Malex')
  }, [currentUser.id, hallNumber])

  const handleReturn = () => {
    history.push(routes.virtualProductLanding)
  }

  return (
    <>
      <StyledTheatre>
        <PageWithBg bgImg={config.assets.theatre.landscape}>
          <div className="side-tv-container">
            <div className={hallNumber === 1 ? 'left-container-sn' : 'left-container-ml'}>
              <img src={hallNumber === 1 ? SmithNephew : MalexLogo} alt="tv-logo" />
            </div>
            <div className={hallNumber === 1 ? 'right-container-sn' : 'right-container-ml'}>
              <img src={hallNumber === 1 ? SmithNephew : MalexLogo} alt="tv-logo" />
            </div>
          </div>
          <div className="center-tv-container">
            {loading && <LoadIcon />}
            {/* to replaced with live url */}
            <iframe
              title="Product Theartre"
              src={`${liveUrl}?autoplay=1&loop=1`}
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setLoading(false)
              }}
            />
            {/* <img src={CenterTV} alt="theatre-screen" /> */}
          </div>

          <div onClick={handleReturn} className="return-button">
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="45px" height="15px" viewBox="0 0 53.514 21.333">
                <path
                  id="Path_23500"
                  data-name="Path 23500"
                  d="M30,8a27.905,27.905,0,0,0-18.4,6.933L6.56,9.893A2.667,2.667,0,0,0,2,11.76V26.667a2.675,2.675,0,0,0,2.667,2.667H19.573a2.675,2.675,0,0,0,1.893-4.56L16.373,19.68A21.236,21.236,0,0,1,49.2,26.667a3.279,3.279,0,0,0,4,1.707,3.346,3.346,0,0,0,2-4.587A28.094,28.094,0,0,0,30,8Z"
                  transform="translate(-2 -8)"
                  fill="#fdfdfd"
                />
              </svg>
            </p>
            <p className="pt-2">Return to Virtual Product Theater</p>
          </div>
        </PageWithBg>
      </StyledTheatre>
    </>
  )
}

export default TheatrePage
